import { IOrganisationConfig } from 'fitbeat.models';
import { loadTheHardcodedStaticOrganisationConfig } from '../../../config/organisationConfig';

const organisationConfig = loadTheHardcodedStaticOrganisationConfig();

export default class DbOrganisationRepository {
  public static getAll(): IOrganisationConfig[] {
    return Object.keys(organisationConfig).map((key: string) => organisationConfig[key]);
  }

  public static get(name: string): IOrganisationConfig {
    return organisationConfig[name];
  }

  public static update(organization: IOrganisationConfig) {
    organisationConfig[organization.name] = organization;
  }

  public static add(organization: IOrganisationConfig) {
    organisationConfig[organization.name] = organization;
  }
}
